<template>
    <div>
        <audio v-if="show" class="audioControls" controls="controls" preload="none"> 
            <source :src="src">
        </audio>
    </div>
</template>

<script>
export default {
    props:['src'],
    data: function(){
        return {
            show: true,
        }
    },
    watch: {
        src: function(data){
            this.show = false;
            setTimeout(()=>{
                this.show = true;
            },100)
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AudioPlayer.vue?5604180b